import { inject, type ComputedRef, type WatchSource, watch } from 'vue';
import { useCheckoutStore } from '@/stores/checkout';

export type UseRecaptchaComposable = {
  ready: ComputedRef<boolean>;
  init: () => Promise<void>;
  executeRecaptcha: (action: string) => Promise<string>;
  executeCheckbox: (action: string) => Promise<string>;
};

type UseRecaptchaParams = {
  autoInit?: boolean;
  initWatcher?: WatchSource<boolean>;
};

const useRecaptcha = ({ autoInit, initWatcher }: UseRecaptchaParams = {}): UseRecaptchaComposable => {
  const recaptcha = inject<UseRecaptchaComposable>('recaptcha');
  if (!recaptcha) {
    throw new Error('useRecaptcha can only be used as a child of RecaptchaProvider.');
  }

  const checkoutStore = useCheckoutStore();

  if (autoInit) {
    if (initWatcher) {
      watch(
        initWatcher,
        async (newValue, oldValue) => {
          if (newValue && !oldValue) {
            try {
              await recaptcha.init();
            } catch {
              // Ignore
            }
          }
        },
        { immediate: true },
      );
    } else {
      recaptcha.init();
    }

    checkoutStore._recaptcha = recaptcha;
  }

  return recaptcha;
};

export { useRecaptcha };
